// extracted by mini-css-extract-plugin
export default {"bottomAd_box":"index_bottomAd_box_8HCHc","bottomAd":"index_bottomAd_l6k9E"};